<as-split direction="horizontal" *ngIf="folder$ | async as folder">
  <as-split-area size="20">
    <filenet-tree class="tree__section" [folder]="folder" [objectStore]="(folderID$ | async)?.objectStore">
    </filenet-tree>
  </as-split-area>
  <as-split-area size="80">

    <ng-container [ngSwitch]="folder?.propertiesObj?.ClassDescription">
      <app-browse-documents *ngSwitchCase="'CategoryFolder'" class="folderTable" [folder]="folder"
        [objectStore]="(folderID$ | async)?.objectStore">
      </app-browse-documents>
      <app-browse-transactions *ngSwitchCase="'TransactionFolder'" class="folderTable" [folder]="folder"
        [objectStore]="(folderID$ | async)?.objectStore">
      </app-browse-transactions>
      <app-browse-folders *ngSwitchDefault [folder]="folder" [objectStore]="(folderID$ | async)?.objectStore">
      </app-browse-folders>
    </ng-container>
  </as-split-area>
